import { staffsRoutesObj, staffsBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";
import { createRoute } from "@/routes/utils";

const permission = [IRole.STAFF, IRole.SUPER_ADMIN];

const staffsRouteMetadata: IRouteMetadataObj<typeof staffsRoutesObj> = {
  list: {
    title: "staffsManagement",
    lazy: () => import("@/pages/adminPanel/usersManagement/staff/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewStaff",
    lazy: () => import("@/pages/adminPanel/usersManagement/staff/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editStaffOf",
    lazy: () => import("@/pages/adminPanel/usersManagement/staff/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewStaffOf",
    lazy: () => import("@/pages/adminPanel/usersManagement/staff/form/page"),
    mode: "view",
    permission,
  },
};

export const staffsRoutes = createRoute<typeof staffsRoutesObj>(
  staffsRoutesObj,
  staffsRouteMetadata,
  staffsBreadcrumbs,
);
